import { useTitle } from "@/lib/img";

const FONTS = [
  { key: "bodoni", label: "Bodoni Moda", className: "font-serif" },
  { key: "italiana", label: "Italiana", className: "font-display" },
];

function Column({ label, className }) {
  return (
    <div data-testid={`type-test-${label.toLowerCase().replace(" ", "-")}`}>
      {/* Dark hero specimen */}
      <div className="bg-ink text-paper px-8 md:px-12 py-14">
        <p className="kicker text-paper/50 mb-10">{label} — Hero</p>
        <p className={`${className} font-light text-[11vw] md:text-[5.5vw] leading-[0.95] tracking-tight`}>
          Architecture
          <br />
          + Interiors
        </p>
        <p className={`${className} italic font-light text-lg md:text-2xl mt-8 text-paper/90`}>
          A boutique California studio crafting spaces worldwide.
        </p>
      </div>

      {/* Light specimens */}
      <div className="bg-paper text-ink px-8 md:px-12 py-14 space-y-14">
        <div>
          <p className="kicker mb-5">{label} — Wordmark</p>
          <p className={`${className} text-2xl md:text-3xl tracking-tight leading-none`}>Medium Plenty</p>
          <p className="text-[9px] uppercase tracking-[0.32em] text-smoke mt-1">Architecture + Interiors</p>
        </div>
        <div>
          <p className="kicker mb-5">{label} — Page Title</p>
          <p className={`${className} font-light text-6xl md:text-7xl leading-[0.95] tracking-tight`}>Projects</p>
        </div>
        <div>
          <p className="kicker mb-5">{label} — Project Name</p>
          <p className={`${className} font-light text-4xl md:text-6xl leading-none tracking-tight`}>Casa Aspetto</p>
        </div>
        <div>
          <p className="kicker mb-5">{label} — Section Heading</p>
          <p className={`${className} font-light text-3xl md:text-5xl tracking-tight`}>Selected Works</p>
        </div>
        <div>
          <p className="kicker mb-5">{label} — Statement</p>
          <p className={`${className} font-light text-2xl md:text-3xl leading-[1.2] tracking-tight max-w-md`}>
            We believe exceptional work begins with exceptional clients
          </p>
        </div>
        <div>
          <p className="kicker mb-5">{label} — Italic / Link Style</p>
          <p className={`${className} italic text-lg`}>
            Inquiries — Let’s make something <span className="italic">lasting</span>
          </p>
        </div>
        <div>
          <p className="kicker mb-5">{label} — Quote</p>
          <p className={`${className} italic font-light text-2xl md:text-3xl leading-[1.2]`}>
            “I work in whatever medium likes me at the moment.”
          </p>
        </div>
      </div>
    </div>
  );
}

export default function TypeTest() {
  useTitle("Type Test | Medium Plenty");
  return (
    <div data-testid="type-test-page" className="pt-24 min-h-screen">
      <div className="px-6 md:px-12 py-10 border-b border-line">
        <p className="kicker mb-3">Hidden Specimen Page</p>
        <h1 className="font-serif font-light text-4xl md:text-5xl tracking-tight">Bodoni Moda vs Italiana</h1>
        <p className="text-smoke text-sm mt-4 max-w-xl">
          Same words, same sizes, side by side. Pick the voice — I'll apply it site-wide in one move.
        </p>
      </div>
      <div className="grid md:grid-cols-2 md:divide-x divide-line">
        {FONTS.map((f) => (
          <Column key={f.key} label={f.label} className={f.className} />
        ))}
      </div>
    </div>
  );
}
